import React from "react";
import { DynamicSelect } from "../../Shared/Components/Select";
import { getStrings } from "../../Shared/Reservation/StringResources";
import { IPassengerDefinition, IPassengerType, maxPassengerCount } from "../Models";
import { Button } from "react-bootstrap";
import Icon from "@mdi/react";
import { mdiAccountMinusOutline, mdiAccountPlusOutline } from "@mdi/js";

const strings = getStrings().component.searchForm;
const commonStrings = getStrings().component.common;

// const invalidAge = -1;
export const PassengerSelector = (props: {
	passengers?: IPassengerDefinition[],
	passengerTypes: IPassengerType[],
	onSetPassengerType: (index: number, type: IPassengerType) => void,
	// onSetPassengerAge: (index: number, age: number) => void,
	onAddPassenger: () => void,
	onRemovePassenger: (index: number) => void }) => {

	const passengers = props.passengers || [];

	// function getAgeOptions(type: IPassengerType)
	// {
	// 	const ageRange = Array.from(range(type.age_from || 0, type.age_to || 120));
	// 	const ageOptions = ageRange.map(x => ({ id:x, name:`${x}`, disabled: false }));
	// 	ageOptions.splice(0, 0, {id: invalidAge, name: strings.selectAge, disabled: true});
	// 	return ageOptions;
	// }

	function passengerTypeChanged(index: number, type: string) {
		const passengerType = props.passengerTypes.find(x => x.code === type);
		if (passengerType)
			props.onSetPassengerType(index, passengerType);
		// if (passengerType.age_from != null || passengerType.age_to != null)
		// 	props.onSetPassengerAge(index, invalidAge);
	}

	function getTypeDescription(type: IPassengerType)
	{
		if (type.ageFrom != null || type.ageTo != null)
			return `${type.description} (${type.ageFrom}-${type.ageTo} ${commonStrings.years})`;
		return type.description;
	}

	return (<>
		{passengers.map((p, idx) =>
			<div className="passenger" key={idx}>
				<DynamicSelect className="categories" value={p.type?.code}
					options={props.passengerTypes.map(x => ({ id: x.code, name: getTypeDescription(x) }))}
					onSelectionChanged={value => passengerTypeChanged(idx, value as string)} />
				{/* {(p.type.age_from != null || p.type.age_to != null) && <>
					<DynamicSelect className={`age ${p.age === invalidAge ? "invalid" : ""}`} value={p.age} options={getAgeOptions(p.type)}
						onSelectionChanged={age => props.onSetPassengerAge(idx, parseInt(age as string))}/> {commonStrings.years}
				</>} */}
				{idx > 0 ? <button onClick={() => props.onRemovePassenger(idx)} type="button" className="btn btn-icon" title={strings.removePassenger}><Icon path={mdiAccountMinusOutline} /></button> : null}
			</div>
		)}
		{ passengers.length < maxPassengerCount &&
			<Button type="button" variant="outline-secondary" onClick={props.onAddPassenger}><Icon path={mdiAccountPlusOutline} />{strings.addPassenger}</Button>}
		</>);
};